import { render, staticRenderFns } from "./CmgRemoteContent.vue?vue&type=template&id=e8d75c8e&scoped=true&lang=pug"
import script from "./cmg-remote-content.ts?vue&type=script&lang=ts&external"
export * from "./cmg-remote-content.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRemoteContent.vue?vue&type=style&index=0&id=e8d75c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d75c8e",
  null
  
)

export default component.exports